<div class="d-block mb-1" style="font-size: 15px">
    <i class="fa-solid fa-square-poll-horizontal me-2"></i>
    {{ 'The customer rated this conversation!' | translate }}
</div>

@for (field of threadElement.fields; track field) {
    <div class="d-flex align-items-center">
        <span class="fw-bold me-1" style="font-size: 13px">
            {{ field.name + ': ' }}
        </span>

        @switch (field.type) {
            @case (fieldTypeEnum.date) {
                {{ field.value | dateTime }}
            }

            @case (fieldTypeEnum.textArea) {
                <br />
                <span [innerHTML]="field.value | newLine | safeHtml"></span>
            }

            @case (fieldTypeEnum.starRating) {
                <ng-container class="ms-2">
                    @for (star of field.options.maxStarCount | numberToArray; track star) {
                        <sb-inline-svg
                            class="icon star-icon"
                            [url]="
                                star <= field.value
                                    ? './sb-tools/theme/images/Svg icons WEB/Settings icons/Star icon - active.svg'
                                    : './sb-tools/theme/images/Svg icons WEB/Settings icons/Star icon - inactive.svg'
                            ">
                        </sb-inline-svg>
                    }
                </ng-container>
            }

            @default {
                {{ field.value }}
            }
        }

        <br />
    </div>
}
